import { CategoryAssemblyType, TransformedAssemblyType } from './types';

export const categoryPageTransformer = (
  category: CategoryAssemblyType,
): TransformedAssemblyType => {
  const categoryChildren =
    category.category?.linkedFrom?.categoryTopicCollection?.items.filter(
      (i) => !!i,
    ) ?? [];

  const categoryChildrenSlugs = categoryChildren.map((categoryChild) => ({
    slug:
      categoryChild?.linkedFrom?.categoryAssemblyCollection?.items[0]?.slug ??
      '',
    title: categoryChild?.title ?? '',
  }));

  return {
    categoryTitle: category.category?.title || '',
    categoryMetadata: category.metadata,
    categoryChildrenSlugs,
  };
};
